import { configureStore } from '@reduxjs/toolkit'
import gameReducer from './Game/gameSlice';
import { apiSlice } from './api/apiSlice';
import { setupListeners } from '@reduxjs/toolkit/query'

const isDebug = Boolean(new URLSearchParams(window.location.search).get("debug"));

export const store = configureStore({
  reducer: {
    game: gameReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck:{
        ignoredPaths:['game.startTime']
      }
    }).concat(apiSlice.middleware),
  devTools: process.env.NODE_ENV === 'development' || isDebug
})

setupListeners(store.dispatch)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store

